export const CancellationStatus = {
  INITIAL: 'initial',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILURE: 'failure',
};

export const CancellationStatuses = Object.values(CancellationStatus);
